import type { AccountableKeyword } from '../../@types/records';

interface RecordAccountableProps {
  accountablePeople: AccountableKeyword[];
}

export default function RecordAccountable({ accountablePeople }: RecordAccountableProps) {
  if (!accountablePeople || accountablePeople.length === 0) return null;

  const names = accountablePeople
    .map((accountable: AccountableKeyword) => accountable.displayName || accountable.value)
    .join(', ');

  const wrapperStyles = 'flex items-center font-bold h-6 cursor-default min-w-min text-xs flex-nowrap shrink-0';

  return <div className={wrapperStyles}>{names}</div>;
}
